import { React, Fragment, useEffect, useCallback, useState } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  CardBody,
  Card,
  CardHeader,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  Input,
  Label,
  FormGroup,
} from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { fetchLocationsRequest } from "../../../redux/location/actions";
import { fetchCountryRequest } from "../../../redux/country/actions";
import { showToast } from "../../Common/Toast";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import { customOptionsStyle, yearsOptions } from "../../../Constant";
import { updatePersonalInfo } from "../../../redux/jobseeker/update_profile/actions";
import {
  fetchJobseekerDataRequest,
  resetData,
} from "../../../redux/jobseeker/fetch_Jobseeker_data/actions";
import {
  yesnoOptions,
  genderOptions,
  maritalStatusOptions,
  categoryOptions,
  readOnlyStyle,
  jobTypeOptions,
  jobShiftOptions,
  monthsOptions,
  experienceOptions,
} from "../../../Constant";

import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css"; // Import styles directly from react-phone-input-2
import validator from "validator";
import {
  convertNumberToWords,
  countryPhoneLengthMap, handleNumberInput
} from "../../Common/CommonFunction";
import { fetchCountriesRequest } from "../../../redux/recruiter/fetch_countries/actions";


const Editpersonal = (props) => {
  const dispatch = useDispatch();

  const [errors, setErrors] = useState({});
  console.log("errors44", errors);
  /**
   * set default form field values
   */
  const [phoneNumberMaxLength, setPhoneNumberMaxLength] = useState(10); // Default max length for phone1
  const [phoneNumber2MaxLength, setPhoneNumber2MaxLength] = useState(10); // Default max length for phone2
  const [locationOptions, setLocationOptions] = useState([]);
  const [countryOptions, setCountryOptions] = useState([]);



  const profileReducerData = useSelector(
    (state) => state.fetchJobseekerDataReducer
  );
  let profileData = [];
  if (!profileReducerData.isLoading && profileReducerData.data.data) {
    profileData = profileReducerData.data.data;
  }

  useEffect(() => {
    if (profileData) {
      const yearsOption = experienceOptions.find(option => option.value == profileData.total_exp_years) || null;
      const monthsOption = monthsOptions.find(option => option.value == profileData.total_exp_months) || null;

      setFormData(prevFormData => ({
        ...prevFormData,
        total_exp_years: yearsOption,
        total_exp_months: monthsOption,
      }));

      // Calculate experience based on the date of birth if it exists
      if (profileData.jobseeker_date_of_birth) {
        const dob = new Date(profileData.jobseeker_date_of_birth);
        calculateExperienceYears(dob);
      }
    }
  }, [profileData]);

  const [formData, setFormData] = useState({
    name:
      (profileData.jobseeker_full_name && profileData.jobseeker_full_name) ||
      "",
    country_code1:
      (profileData.country_code1 && profileData.country_code1) || "91",
    country_code2:
      (profileData.country_code2 && profileData.country_code2) || "",
    jobseeker_phone1:
      (profileData.jobseeker_phone1 && profileData.jobseeker_phone1) || "",
    jobseeker_email1:
      (profileData.jobseeker_email1 && profileData.jobseeker_email1) || "",
    jobseeker_email2:
      (profileData.jobseeker_email2 && profileData.jobseeker_email2) || "",
    jobseeker_phone2:
      (profileData.jobseeker_phone2 && profileData.jobseeker_phone2) || "",
    location:
      (profileData.jobseeker_location && profileData.jobseeker_location) || "",

    date_of_birth: profileData.jobseeker_date_of_birth
      ? new Date(profileData.jobseeker_date_of_birth)
      : null,

    paddress:
      (profileData.jobseeker_permanent_address &&
        profileData.jobseeker_permanent_address) ||
      "",
    jobseeker_gender:
      (profileData.jobseeker_gender &&
        genderOptions.find(
          (option) => option.value == profileData.jobseeker_gender
        )) ||
      null,

    pincode:
      (profileData.jobseeker_pincode && profileData.jobseeker_pincode) || "",
    marital_status:
      maritalStatusOptions.find((option) => {
        if (option.value == profileData.jobseeker_marital_status) {
          return option;
        }
      }) || "",
    home_town:
      (profileData.jobseeker_hometown && profileData.jobseeker_hometown) || "",

    jobseeker_work_permit_for_other_countries:
      (profileData.jobseeker_work_permit_for_other_countries &&
        profileData.jobseeker_work_permit_for_other_countries) ||
      "",
    differently_abled:
      yesnoOptions.find((option) => {
        if (option.value == profileData.jobseeker_differently_abled) {
          return option;
        }
      }) || yesnoOptions[1],
    total_exp_years:
      experienceOptions.find((option) => {
        if (option.value == profileData.total_exp_years) {
          return option;
        }
      }) || "",
    total_exp_months:
      monthsOptions.find((option) => {
        if (option.value == profileData.total_exp_months) {
          return option;
        }
      }) || "",

    jobseeker_notice_period: profileData.jobseeker_notice_period,
    jobseeker_preferred_location:
      (profileData.jobseeker_preferred_location &&
        profileData.jobseeker_preferred_location) ||
      "",
    jobseeker_preferred_salary: profileData.jobseeker_preferred_salary || "",
    jobseeker_current_salary: profileData.jobseeker_current_salary || "",
    jobseeker_preferred_job_type:
      jobTypeOptions.find(
        (option) => option.value == profileData.jobseeker_preferred_job_type
      ) || null,
    jobseeker_preferred_shift:
      jobShiftOptions.find(
        (option) => option.value == profileData.jobseeker_preferred_shift
      ) || null,
    relevant_experience: profileData.relevant_experience || "",
  });


  const [filteredExperienceOptions, setFilteredExperienceOptions] = useState(experienceOptions);


  // handle date chage
  const handleDateChange = (date) => {
    const updatedErrors = { ...errors, date_of_birth: "" };
    setErrors(updatedErrors);

    // Define the min and max dates
    const minDate = new Date(1975, 0, 1); // January 1, 1975
    const maxDate = new Date(2008, 11, 31); // December 31, 2008

    // Validate the selected date
    if (date < minDate || date > maxDate) {
      updatedErrors.date_of_birth = "Date of birth must be between 01-01-1975 and 31-12-2008.";
      setErrors(updatedErrors);
      return; // Exit if the date is invalid
    }

    setFormData({ ...formData, date_of_birth: date });
    calculateExperienceYears(date);
  };


  const calculateExperienceYears = (dob) => {
    if (dob) {
      const currentYear = new Date().getFullYear();
      const birthYear = dob.getFullYear();
      const age = currentYear - birthYear;

      // Calculate experience years after skipping 16 years
      const experience = age > 16 ? age - 16 : 0;

      generateExperienceOptions(experience);
    }
  };

  const generateExperienceOptions = (experience) => {
    const options = experienceOptions.filter(option => parseInt(option.value) <= experience);
    setFilteredExperienceOptions(options);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validate()) {
      const data = {
        jobseeker_full_name: formData.name || "",
        country_code1: formData.country_code1 || "",
        country_code2: formData.country_code2 || "",
        jobseeker_phone1: formData.jobseeker_phone1 || "",
        jobseeker_phone2: formData.jobseeker_phone2 || "",
        jobseeker_email1: formData.jobseeker_email1 || "",
        jobseeker_email2: formData.jobseeker_email2 || "",
        jobseeker_location: formData.location ? formData.location.value : "",
        jobseeker_preferred_location: formData.jobseeker_preferred_location
          ? formData.jobseeker_preferred_location
            .map((loc) => loc.value)
            .join(",")
          : "",
        total_exp_years: formData.total_exp_years
          ? formData.total_exp_years.value
          : "",
        total_exp_months: formData.total_exp_months
          ? formData.total_exp_months.value
          : "",
        jobseeker_pincode: formData.pincode || "",
        jobseeker_notice_period: formData.jobseeker_notice_period || "",
        jobseeker_preferred_salary: formData.jobseeker_preferred_salary || "",
        jobseeker_current_salary: formData.jobseeker_current_salary || "",
        jobseeker_date_of_birth: formData.date_of_birth || "",
        jobseeker_permanent_address: formData.paddress || "",
        jobseeker_gender: formData.jobseeker_gender
          ? formData.jobseeker_gender.value
          : "",
        jobseeker_jobseeker_pincode: formData.pincode || "",
        jobseeker_marital_status: formData.marital_status
          ? formData.marital_status.value
          : "",
        jobseeker_hometown: formData.home_town || "",
        jobseeker_work_permit_for_other_countries:
          formData.jobseeker_work_permit_for_other_countries
            ? formData.jobseeker_work_permit_for_other_countries
              .map((permit) => permit.value)
              .join(",")
            : "",
        jobseeker_differently_abled: formData.differently_abled
          ? formData.differently_abled.value
          : "",
      };

      dispatch(updatePersonalInfo(data));
    }
  };

  // validate form data

  const validate = () => {
    let errors = {};
    let isValid = true;

    if (!formData.name) {
      errors.name = "Name is required";
      isValid = false;
    }

    const trimmedPhoneNumber = formData.jobseeker_phone1.trim();
    if (!trimmedPhoneNumber) {
      errors.jobseeker_phone1 = "Phone number is required";
      isValid = false;
    } else if (formData.country_code1 === "91" && trimmedPhoneNumber.length !== 10) {
      errors.jobseeker_phone1 = "Phone number must be 10 digits for India";
      isValid = false;
    } else if (formData.country_code1 === "91" && !/^[6-9]\d{9}$/.test(trimmedPhoneNumber)) {
      errors.jobseeker_phone1 = "Phone number cannot be start with 0 to 5";
      isValid = false;
    } else if (isNaN(trimmedPhoneNumber)) {
      errors.jobseeker_phone1 = "Phone number must be a valid number";
      isValid = false;
    } else if (/^0{10}$/.test(trimmedPhoneNumber)) { // Check for 0000000000
      errors.jobseeker_phone1 = "Phone number cannot be all zeros";
      isValid = false;
    } else if (!validator.isMobilePhone(trimmedPhoneNumber, "any", { strictMode: false })) {
      errors.jobseeker_phone1 = "Invalid phone number format";
      isValid = false;
    }


    // const trimmedPhoneNumber2 = formData.jobseeker_phone2.trim();
    // if (trimmedPhoneNumber2) {
    //   // Check for length if the country code is India
    //   if (formData.country_code2 === "91" && trimmedPhoneNumber2.length !== 10) {
    //     errors.jobseeker_phone2 = "Phone number must be 10 digits for India";
    //     isValid = false;
    //   }
    //   else if (formData.country_code2 === "91" && !/^[6-9]\d{9}$/.test(trimmedPhoneNumber2)) {
    //     errors.jobseeker_phone2 = "Phone number cannot be start with 0 to 5";
    //     isValid = false;
    //   }

    //   // Check if the phone number is a valid number
    //   else if (isNaN(trimmedPhoneNumber2)) {
    //     errors.jobseeker_phone2 = "Phone number must be a valid number";
    //     isValid = false;
    //   }
    //   // Check for all zeros
    //   else if (/^0{10}$/.test(trimmedPhoneNumber2)) { // Check for 0000000000
    //     errors.jobseeker_phone2 = "Phone number cannot be all zeros";
    //     isValid = false;
    //   }
    //   // Check for valid mobile phone format
    //   else if (!validator.isMobilePhone(trimmedPhoneNumber2, "any", { strictMode: false })) {
    //     errors.jobseeker_phone2 = "Invalid phone number format";
    //     isValid = false;
    //   }
    // } commented on 29-08-2025 by aman maurya for mandatory validation

    const trimmedPhoneNumber2 = formData.jobseeker_phone2.trim();
    if (trimmedPhoneNumber2){
    if (formData.country_code1 === "91" && trimmedPhoneNumber2.length !== 10) {
      errors.jobseeker_phone2 = "Phone number must be 10 digits for India";
      isValid = false;
    } else if (formData.country_code1 === "91" && !/^[6-9]\d{9}$/.test(trimmedPhoneNumber2)) {
      errors.jobseeker_phone2 = "Phone number cannot be start with 0 to 5";
      isValid = false;
    } else if (isNaN(trimmedPhoneNumber2)) {
      errors.jobseeker_phone2 = "Phone number must be a valid number";
      isValid = false;
    } else if (/^0{10}$/.test(trimmedPhoneNumber2)) { // Check for 0000000000
      errors.jobseeker_phone2 = "Phone number cannot be all zeros";
      isValid = false;
    } else if (!validator.isMobilePhone(trimmedPhoneNumber2, "any", { strictMode: false })) {
      errors.jobseeker_phone2 = "Invalid phone number format";
      isValid = false;
    }
  }

    // Check if primary and secondary phone numbers are identical
    if (
      trimmedPhoneNumber &&
      trimmedPhoneNumber2 &&
      trimmedPhoneNumber === trimmedPhoneNumber2
    ) {
      errors.jobseeker_phone2 =
        "Primary and secondary phone numbers must not be identical";
      isValid = false;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,6}$/;
    if (
      formData.jobseeker_email2 &&
      !emailRegex.test(formData.jobseeker_email2)
    ) {
      errors.jobseeker_email2 = "Please enter valid email";
      isValid = false;
    }

    // Check if primary and secondary emails are identical
    if (
      formData.jobseeker_email1 &&
      formData.jobseeker_email2 &&
      formData.jobseeker_email1.trim() === formData.jobseeker_email2.trim()
    ) {
      errors.jobseeker_email2 = "Primary and secondary email addresses must not be identical";
      isValid = false;
    }

    if (!formData.location) {
      errors.location = "Current location is required";
      isValid = false;
    }

    if (
      !formData.jobseeker_preferred_location ||
      formData.jobseeker_preferred_location.length == 0
    ) {
      errors.jobseeker_preferred_location = "Preferred location is required";
      isValid = false;
    }

    if (!formData.date_of_birth) {
      errors.date_of_birth = "Date of birth is required";
      isValid = false;
    } else {
      const minDate = new Date(1975, 0, 1); // January 1, 1975
      const maxDate = new Date(2008, 11, 31); // December 31, 2008
      if (formData.date_of_birth < minDate || formData.date_of_birth > maxDate) {
        errors.date_of_birth = "Date of birth must be between 01-01-1975 and 31-12-2008.";
        isValid = false;
      }
    }

    if (!formData.jobseeker_gender) {
      errors.jobseeker_gender = "Gender is required";
      isValid = false;
    }

    // Pincode optional; validate format when provided
    const pincode = (formData.pincode || "").trim();
    if (pincode) {
      if (isNaN(pincode)) {
        errors.pincode = "Pincode must be a valid number";
        isValid = false;
      } else if (pincode.length !== 6) {
        errors.pincode = "Pincode must be 6 digits long";
        isValid = false;
      }
    }

    if (!formData.marital_status) {
      errors.marital_status = "Marital status is required";
      isValid = false;
    }

    // if (!formData.differently_abled) {
    //   errors.differently_abled = "Differently abled is required";
    //   isValid = false;
    // }

    if (!formData.total_exp_years && !formData.total_exp_months) {
      errors.total_exp_years =
        "Total experience (either in years or months) is required";
      isValid = false;
    }

    if (!formData.jobseeker_notice_period) {
      errors.jobseeker_notice_period = "Notice period is required";
      isValid = false;
    } else if (isNaN(formData.jobseeker_notice_period)) {
      errors.jobseeker_notice_period = "Notice period must be a number";
      isValid = false;
    }

    if (!formData.jobseeker_preferred_salary) {
      errors.jobseeker_preferred_salary = "Expected CTC is required";
      isValid = false;
    } else if (isNaN(formData.jobseeker_preferred_salary)) {
      errors.jobseeker_preferred_salary = "Expected CTC must be a number";
      isValid = false;
    } else if (parseFloat(formData.jobseeker_preferred_salary) < parseFloat(formData.jobseeker_current_salary)) {
      errors.jobseeker_preferred_salary = "Expected CTC cannot be less than Current CTC";
      isValid = false;
    }

    if (!formData.jobseeker_current_salary) {
      errors.jobseeker_current_salary = "Current CTC is required";
      isValid = false;
    } else if (isNaN(formData.jobseeker_current_salary)) {
      errors.jobseeker_current_salary = "Current CTC must be a number";
      isValid = false;
    }

    setErrors(errors);
    return isValid;
  };
  // const maxSalary = 9900000000; // 99 crore
  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   let error = "";

  //   setErrors({ ...errors, [name]: error });
  //   setFormData({
  //     ...formData,
  //     [name]: value,
  //   });

  // };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let error = "";

    // Update form data
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));

    // Clear the error message for the updated field
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));

    // Validation logic for current and expected CTC
    const currentSalary = name === "jobseeker_current_salary" ? parseFloat(value) : parseFloat(formData.jobseeker_current_salary);
    const preferredSalary = name === "jobseeker_preferred_salary" ? parseFloat(value) : parseFloat(formData.jobseeker_preferred_salary);

    if (name === "jobseeker_preferred_salary") {
      if (currentSalary && preferredSalary < currentSalary) {
        error = "Expected CTC cannot be less than Current CTC";
      }
    }

    // Update the error state
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: error,
    }));
  };

  const handleGenderChange = (selectedOption) => {
    // Clear the error message when an option is selected
    const updatedErrors = { ...errors, jobseeker_gender: "" };
    setErrors(updatedErrors);

    // Update the form state with selected values
    setFormData({ ...formData, jobseeker_gender: selectedOption });
  };

  const handleDifferentlyAbledChange = (selectedOption) => {
    // Clear the error message when an option is selected
    const updatedErrors = { ...errors, differently_abled: "" };
    setErrors(updatedErrors);

    // Update the form state with selected values
    setFormData({ ...formData, differently_abled: selectedOption });
  };

  const handleMaritalStatusChange = (selectedOption) => {
    // Clear the error message when an option is selected
    const updatedErrors = { ...errors, marital_status: "" };
    setErrors(updatedErrors);

    // Update the form state with selected values
    setFormData({ ...formData, marital_status: selectedOption });
  };

  /**
   * location dropdown code start
   */
  //read location data from store
  let locationReducerData = useSelector((state) => state.locationReducer);
  let locationData = locationReducerData.data.data;

  useEffect(() => {
    locationData = locationData || [];
    setLocationOptions(locationData);
  }, [locationData]);

  const handleLocationFocus = () => {
    // This function will be called when the location dropdown is focused
    // You can trigger your API call here
    const fetchData = async () => {
      try {
        const keyword = ""; // Set your keyword value here
        dispatch(fetchLocationsRequest(keyword));
      } catch (error) {
        console.error(error);
      }
    };

    // Call the fetchData function when the location dropdown is focused
    fetchData();
  };

  // Callback to handle location input change
  const handleLocationInputChange = useCallback((inputValue) => {
    // Fetch data based on the inputValue (keyword)
    const fetchData = async () => {
      try {
        dispatch(fetchLocationsRequest(inputValue));
      } catch (error) {
        // Handle any errors if necessary
      }
    };

    // Call the fetchData function when the location input changes
    fetchData();
  }, []);

  // Callback to handle location select change
  const handleLocationsChange = (selectedOptions) => {
    // Clear the error message when an option is selected
    const updatedErrors = { ...errors, location: "" };
    setErrors(updatedErrors);

    // Update the form state with selected values
    setFormData({ ...formData, location: selectedOptions });
  };

  // const totalYearExperienceChange = (selectedOptions) => {
  //   const updatedErrors = { ...errors, total_exp_years: "" };
  //   setErrors(updatedErrors);

  //   // Update the form state with selected values
  //   setFormData({ ...formData, total_exp_years: selectedOptions });
  // };

  const totalYearExperienceChange = (selectedOptions) => {
    const updatedErrors = { ...errors, total_exp_years: "" };
    setErrors(updatedErrors);
  
    const years = parseInt(selectedOptions?.value || 0);
    const months = parseInt(formData.total_exp_months?.value || 0);
  
    const isFresher = years === 0 && months === 0;
  
    setFormData({
      ...formData,
      total_exp_years: selectedOptions,
      jobseeker_notice_period: isFresher ? "0" : "",
      jobseeker_current_salary: isFresher ? "0" : "",
    });
  };

  // const totalMonthExperienceChange = (selectedOptions) => {
  //   const updatedErrors = { ...errors, total_exp_years: "" };
  //   setErrors(updatedErrors);

  //   // Update the form state with selected values
  //   setFormData({ ...formData, total_exp_months: selectedOptions });
  // };

  const totalMonthExperienceChange = (selectedOptions) => {
    const updatedErrors = { ...errors, total_exp_years: "" };
    setErrors(updatedErrors);
  
    const years = parseInt(formData.total_exp_years?.value || 0);
    const months = parseInt(selectedOptions?.value || 0);
  
    const isFresher = years === 0 && months === 0;
  
    setFormData({
      ...formData,
      total_exp_months: selectedOptions,
      jobseeker_notice_period: isFresher ? "0" : "",
      jobseeker_current_salary: isFresher ? "0" : "",
    });
  };

  /**
   * location dropdown code end
   */

  /**
   * country dropdown code start
   */
  //read country data from store
  let countryReducerData = useSelector((state) => state.fetchCountriesReducer);
  let countryData = countryReducerData.data;

  useEffect(() => {
    // Check if countryData.data is an array before mapping
    if (countryData && Array.isArray(countryData.data)) {
      setCountryOptions(
        countryData.data.map((country) => ({
          label: country.label || "Unknown", // Adjust based on your country data structure
          value: country.value, // Adjust based on your country data structure
        }))
      );
    } else {
      console.error("countryData.data is not an array:", countryData);
    }
  }, [countryData]);

  const handleCountryFocus = () => {
    // This function will be called when the location dropdown is focused
    // You can trigger your API call here

    const fetchData = async () => {
      try {
        const keyword = ""; // Set your keyword value here
        dispatch(fetchCountriesRequest());
      } catch (error) {
        console.error(error);
      }
    };

    // Call the fetchData function when the location dropdown is focused
    fetchData();
  };

  // Callback to handle location input change
  const handleCountryInputChange = useCallback((inputValue) => {
    // Fetch data based on the inputValue (keyword)
    const fetchData = async () => {
      try {
        dispatch(fetchCountriesRequest({
          keyword: inputValue,
        }));
      } catch (error) {
        // Handle any errors if necessary
      }
    };

    // Call the fetchData function when the location input changes
    fetchData();
  }, []);

  // Callback to handle location select change
  const handleCountryChange = (selectedOptions) => {
    // Clear the error message when an option is selected
    const updatedErrors = { ...errors, work_permit: "" };
    setErrors(updatedErrors);

    // Update the form state with selected values
    setFormData({
      ...formData,
      jobseeker_work_permit_for_other_countries: selectedOptions,
    });
  };

  /**
   * country dropdown code end
   */
  const jobseekerProfileReducerData = useSelector(
    (state) => state.jobseekerProfileReducer
  );
  useEffect(() => {
    if (
      jobseekerProfileReducerData.status &&
      jobseekerProfileReducerData.message != ""
    ) {
      showToast("success", jobseekerProfileReducerData.message);
      dispatch(fetchJobseekerDataRequest());
      props.toggleModal();
      dispatch(resetData());
    } else if (
      jobseekerProfileReducerData.status == false &&
      jobseekerProfileReducerData.message != ""
    ) {
      showToast("error", jobseekerProfileReducerData.message);
      // dispatch(fetchJobseekerDataRequest());
      // props.toggleModal();
      dispatch(resetData());
    }
  }, [jobseekerProfileReducerData]);

  const handleCodeChange = (value, country) => {
    // Extract only the phone number without the country code
    const phoneNumberWithoutCode = value
      .replace(`+${country.dialCode}`, "")
      .trim();
    // Removing non-digit characters and ensuring country code is included
    const formattedPhoneNumber = `+${country.dialCode}${value
      .replace(/\D/g, "")
      .slice(country.dialCode.length)}`;
    setFormData({
      ...formData,

      country_code1: country.dialCode,
      jobseeker_phone1: "", // Resetting phone field when country changes, optional
    });
    // Update max length based on the selected country code
    const newMaxLength = countryPhoneLengthMap[country.dialCode] || 15; // default to 15 if not found
    setPhoneNumberMaxLength(newMaxLength); // This assumes you have a state that holds the max length
  };

  const handleCodeChange2 = (value, country) => {
    // Extract only the phone number without the country code
    const phoneNumberWithoutCode = value
      .replace(`+${country.dialCode}`, "")
      .trim();
    // Removing non-digit characters and ensuring country code is included
    const formattedPhoneNumber = `+${country.dialCode}${value
      .replace(/\D/g, "")
      .slice(country.dialCode.length)}`;
    setFormData({
      ...formData,

      country_code2: country.dialCode,
      jobseeker_phone1: "", // Resetting phone field when country changes, optional
    });
    // Update max length based on the selected country code
    const newMaxLength = countryPhoneLengthMap[country.dialCode] || 15; // default to 15 if not found
    setPhoneNumber2MaxLength(newMaxLength); // This assumes you have a state that holds the max length
  };

  // Callback to handle location select change
  const handlePreferedLocationsChange = (selectedOptions) => {
    // Clear the error message when an option is selected
    const updatedErrors = { ...errors, jobseeker_preferred_location: "" };
    setErrors(updatedErrors);

    // Update the form state with selected values
    setFormData({ ...formData, jobseeker_preferred_location: selectedOptions });
  };

  const handleJobTypeChange = (selectedOption) => {
    // Clear the error message when an option is selected
    const updatedErrors = { ...errors, jobseeker_preferred_job_type: "" };
    setErrors(updatedErrors);

    // Update formData directly
    setFormData({
      ...formData,
      jobseeker_preferred_job_type: selectedOption, // Set the selected value
    });
  };

  const handleJobShiftChange = (selectedOption) => {
    // Clear the error message when an option is selected
    const updatedErrors = { ...errors, jobseeker_preferred_shift: "" };
    setErrors(updatedErrors);
    console.log(selectedOption);

    // Update formData directly
    setFormData({
      ...formData,
      jobseeker_preferred_shift: selectedOption,
    });
  };

  return (
    <Modal
      isOpen={props.isOpen}
      toggle={props.toggleModal}
      centered
      className="modal-lg"
    >
      <Form className="theme-form" onSubmit={handleSubmit}>
        <ModalHeader className="border-0" toggle={props.toggleModal}>
          <h4>Edit Personal Info</h4>
        </ModalHeader>
        <ModalBody className="pt-0">
          <h5 className="mb-3 text-purple">Personal Info</h5>
          <Row>
            <Col md={6}>
              <FormGroup>
                <Label>
                  Name
                  <span className="font-danger">*</span>
                </Label>
                <Input
                  type="text"
                  name="name"
                  className="form-control form-control-sm"
                  placeholder="Enter your name"
                  value={formData.name}
                  onChange={(e) => {
                    const { value } = e.target;

                    // Validates if the input value contains only alphabetic characters (and spaces)
                    if (/^[A-Za-z\s]*$/.test(value)) {
                      handleChange(e); // Call your existing handleChange function
                    } else {
                      // Optionally, set an error message or provide feedback
                      const updatedErrors = {
                        ...errors,
                        full_name: "Only alphabetic characters are allowed.",
                      };
                      setErrors(updatedErrors);
                    }
                  }}
                  maxLength={50}
                />
                {errors.name && (
                  <small className="text-danger">{errors.name}</small>
                )}
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="date_of_birth">
                  Date of Birth
                  <span className="font-danger">*</span>
                </Label>
                <DatePicker
                  showYearDropdown
                  showMonthDropdown
                  className="form-control form-control-sm mb-0"
                  selected={formData.date_of_birth}
                  onChange={handleDateChange}
                  dateFormat="dd-MM-yyyy"
                  placeholderText="Enter your date of birth"
                  dropdownMode="select"
                />
                {errors.date_of_birth && (
                  <small className="text-danger">{errors.date_of_birth}</small>
                )}
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label>
                  Primary Email <span className="font-danger">*</span>
                </Label>
                <Input
                  type="text"
                  name="jobseeker_email1"
                  className="form-control form-control-sm "
                  placeholder="Enter your email "
                  value={formData.jobseeker_email1}
                  readOnly // Set the readOnly attribute
                  style={readOnlyStyle}
                  maxLength={50}
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label>Secondary Email </Label>
                <Input
                  type="text"
                  name="jobseeker_email2"
                  className="form-control form-control-sm"
                  placeholder="Enter second email"
                  value={formData.jobseeker_email2}
                  onChange={handleChange}
                  maxLength={50} // Set the maximum length here
                />
                {errors.jobseeker_email2 && (
                  <small className="text-danger">
                    {errors.jobseeker_email2}
                  </small>
                )}
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label>
                  Primary Mobile <span className="text-danger">*</span>
                </Label>
                <div className="d-flex">
                  <PhoneInput
                    style={{
                      width: "10px",
                      marginRight: "10px",
                    }}
                    inputProps={{
                      name: "phone",
                      autoFocus: true,
                      disabled: true,
                      // placeholder: "Enter country code",
                    }}
                    country={"in"} // Default country
                    value={formData.country_code1}
                    onChange={handleCodeChange}
                    inputStyle={{
                      width: "100px", // Adjust width to fit country code
                      height: "38px",
                      //padding: "0.375rem 2.2rem", // Adjust padding to fit correctly
                      paddingLeft: "3rem",
                      fontSize: "1rem",
                      lineHeight: "1.5",
                      color: "#495057",
                      backgroundColor: "#fff",
                      backgroundClip: "padding-box",
                      border: "1px solid #ced4da",
                      borderRadius: ".25rem",
                      transition:
                        "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
                    }}
                    enableAreaCodes={false}
                  />
                  <Input
                    // type="number"
                    className="form-control form-control-sm"
                    placeholder="Enter your phone number"
                    id="jobseeker_phone1"
                    name="jobseeker_phone1"
                    value={formData.jobseeker_phone1}
                    onWheel={(e) => e.target.blur()} // Prevents the number input from showing the spinner
                    onInput={(e) => {
                      const value = e.target.value;
                      // Check if the value is a valid number and respects phoneNumberMaxLength
                      if (
                        (value === "" || /^[0-9]*$/.test(value)) && // Allow only digits
                        value.length <= phoneNumberMaxLength // Limit based on phoneNumberMaxLength
                      ) {
                        handleChange(e); // Call your existing handleChange function
                      }
                    }}
                    style={{ marginLeft: "95px" }} // Add margin to separate the fields
                  />
                </div>

                {errors.jobseeker_phone1 && (
                  <small className="text-danger">
                    {errors.jobseeker_phone1}
                  </small>
                )}
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label>Secondary Mobile</Label>
                <div className="d-flex">
                  <PhoneInput
                    style={{
                      width: "10px",
                      marginRight: "10px",
                    }}
                    inputProps={{
                      name: "phone",
                      autoFocus: true,
                      disabled: true,
                      // placeholder: "Enter country code",
                    }}
                    country={"in"} // Default country
                    value={formData.country_code2}
                    onChange={handleCodeChange2}
                    inputStyle={{
                      width: "100px", // Adjust width to fit country code
                      height: "38px",
                      //padding: "0.375rem 2.2rem", // Adjust padding to fit correctly
                      paddingLeft: "3rem",
                      fontSize: "1rem",
                      lineHeight: "1.5",
                      color: "#495057",
                      backgroundColor: "#fff",
                      backgroundClip: "padding-box",
                      border: "1px solid #ced4da",
                      borderRadius: ".25rem",
                      transition:
                        "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
                    }}
                    enableAreaCodes={false}
                  />
                  <Input
                    // type="number"
                    className="form-control form-control-sm"
                    placeholder="Enter second phone number"
                    id="jobseeker_phone2"
                    name="jobseeker_phone2"
                    value={formData.jobseeker_phone2}
                    onWheel={(e) => e.target.blur()} // Prevents the number input from showing the spinner
                    onInput={(e) => {
                      const value = e.target.value;
                      // Check if the value is a valid number and respects phoneNumberMaxLength
                      if (
                        (value === "" || /^[0-9]*$/.test(value)) && // Allow only digits
                        value.length <= phoneNumber2MaxLength // Limit based on phoneNumberMaxLength
                      ) {
                        handleChange(e); // Call your existing handleChange function
                      }
                    }}
                    style={{ marginLeft: "95px" }} // Add margin to separate the fields
                  />
                </div>

                {errors.jobseeker_phone2 && (
                  <small className="text-danger">
                    {errors.jobseeker_phone2}
                  </small>
                )}
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label>
                  Gender
                  <span className="font-danger">*</span>
                </Label>
                <Select
                  placeholder="Select gender"
                  options={genderOptions}
                  name="jobseeker_gender"
                  value={formData.jobseeker_gender}
                  onChange={handleGenderChange}
                />
                {errors.jobseeker_gender && (
                  <small className="text-danger">
                    {errors.jobseeker_gender}
                  </small>
                )}
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label>
                  Marital Status
                  <span className="font-danger">*</span>
                </Label>
                <Select
                  placeholder="Select marital status"
                  options={maritalStatusOptions}
                  name="marital_status"
                  value={formData.marital_status}
                  onChange={handleMaritalStatusChange}
                />
                {errors.marital_status && (
                  <small className="text-danger">{errors.marital_status}</small>
                )}
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="differently_abled">
                  Differently Abled
                  {/* <span className="font-danger">*</span> */}
                </Label>
                <Select
                  placeholder="Select differently abled"
                  options={yesnoOptions}
                  name="differently_abled"
                  value={formData.differently_abled}
                  onChange={handleDifferentlyAbledChange}
                />
                {errors.differently_abled && (
                  <small className="text-danger">
                    {errors.differently_abled}
                  </small>
                )}
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="address">
                  Permanent Address
                </Label>
                <Input
                  type="text"
                  name="paddress"
                  className="form-control form-control-sm"
                  placeholder="Enter permanent address"
                  value={formData.paddress}
                  onChange={handleChange}
                  maxLength={250}
                />
                {errors.paddress && (
                  <small className="text-danger">{errors.paddress}</small>
                )}
              </FormGroup>
            </Col>

            <Col md={6}>
              <FormGroup>
                <Label for="hometown">
                  Home Town
                </Label>
                <Input
                  type="text"
                  name="home_town"
                  className="form-control form-control-sm"
                  placeholder="Enter home town"
                  value={formData.home_town}
                  onChange={handleChange}
                  maxLength={100}
                />
                {errors.home_town && (
                  <small className="text-danger">{errors.home_town}</small>
                )}
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label>
                  Pincode
                </Label>
                <Input
                  // type="number"
                  name="pincode"
                  className="form-control form-control-sm"
                  placeholder="Enter pincode"
                  value={formData.pincode}
                  min={100000} // Minimum value for a 6-digit pincode
                  max={999999} // Maximum value for a 6-digit pincode
                  onWheel={(e) => e.target.blur()} // Prevents the number input from showing the spinner
                  onInput={(e) => handleNumberInput(e, handleChange, 1, 999999)}
                />
                {errors.pincode && (
                  <small className="text-danger">{errors.pincode}</small>
                )}
              </FormGroup>
            </Col>
          </Row>
          <h5 className="mb-3 mt-2 text-purple">Professional Info</h5>
          <Row>
            <Col md={12}>
              <Label>
                Total Experience <span className="font-danger">*</span>
              </Label>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Select
                  options={filteredExperienceOptions}
                  value={formData.total_exp_years}
                  onChange={totalYearExperienceChange}
                  styles={customOptionsStyle}
                  placeholder="Select years"
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Select
                  placeholder="Select month"
                  options={monthsOptions}
                  value={formData.total_exp_months}
                  onChange={totalMonthExperienceChange}
                />
              </FormGroup>
            </Col>
            {errors.total_exp_years && (
              <small className="text-danger">{errors.total_exp_years}</small>
            )}
            {/* <Col md="6">
              <FormGroup>
                <Label for="relevant_experience">
                  Relevant Experience (Months){" "}
                </Label>
                <Input
                  type="number"
                  name="relevant_experience"
                  className="form-control form-control-sm"
                  placeholder="Relevant experience"
                  onChange={handleChange}
                  value={formData.relevant_experience}
                />
                {errors.relevant_experience && (
                  <small className="text-danger">
                    {errors.relevant_experience}
                  </small>
                )}
              </FormGroup>
            </Col> */}

            <Col md="6">
              <FormGroup>
                <Label for="jobseeker_preferred_salary">
                  Notice period <span className="font-danger">*</span>
                </Label>
                <Input
                  // type="number"
                  name="jobseeker_notice_period"
                  className="form-control form-control-sm"
                  placeholder="Enter notice period"
                  onInput={(e) => handleNumberInput(e, handleChange, 0, 365)}
                  value={formData.jobseeker_notice_period}
                />
                {errors.jobseeker_notice_period && (
                  <small className="text-danger">
                    {errors.jobseeker_notice_period}
                  </small>
                )}
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="work_permit_location">Foreign Work Permit</Label>
                <Select
                  name="jobseeker_work_permit_for_other_countries"
                  isMulti
                  options={countryOptions}
                  isLoading={countryReducerData.isLoading}
                  placeholder="Select country"
                  value={formData.jobseeker_work_permit_for_other_countries}
                  onChange={handleCountryChange}
                  onInputChange={handleCountryInputChange}
                  styles={customOptionsStyle}
                  onFocus={handleCountryFocus}
                />
              </FormGroup>
            </Col>
          </Row>
          <h5 className="mb-3 mt-2 text-purple">Location</h5>
          <Row>
            <Col md={6}>
              <FormGroup>
                <Label>
                  Current Location <span className="font-danger">*</span>
                </Label>
                <Select
                  options={locationOptions}
                  isLoading={locationReducerData.isLoading}
                  placeholder="Select current locations"
                  value={formData.location}
                  onChange={handleLocationsChange}
                  onInputChange={handleLocationInputChange}
                  styles={customOptionsStyle}
                  onFocus={handleLocationFocus}
                />{" "}
                {errors.location && (
                  <small className="text-danger">{errors.location}</small>
                )}
              </FormGroup>
            </Col>
            <Col md="6">
              <FormGroup>
                <Label for="jobseeker_preferred_location">
                  Preferred Location <span className="font-danger">*</span>
                </Label>
                <Select
                  isMulti
                  options={locationOptions}
                  isLoading={locationReducerData.isLoading}
                  placeholder="Select preferred locations"
                  value={formData.jobseeker_preferred_location}
                  onChange={handlePreferedLocationsChange}
                  onInputChange={handleLocationInputChange}
                  styles={customOptionsStyle}
                  onFocus={handleLocationFocus}
                />
                {errors.jobseeker_preferred_location && (
                  <small className="text-danger">
                    {errors.jobseeker_preferred_location}
                  </small>
                )}
              </FormGroup>
            </Col>
          </Row>
          <h5 className="mb-3 mt-2 text-purple">Salary</h5>
          <Row>
            <Col md="6">
              <FormGroup>
                <Label for="jobseeker_current_salary">
                  Current CTC <span className="font-danger">*</span>
                </Label>
                <Input
                  // type="number"
                  name="jobseeker_current_salary"
                  className="form-control form-control-sm"
                  placeholder="Enter current ctc"
                  onInput={(e) => handleNumberInput(e, handleChange, 0, 990000000)}
                  value={formData.jobseeker_current_salary}
                // max={maxSalary} // Set the maximum limit
                />
                {formData.jobseeker_current_salary &&
                  !isNaN(formData.jobseeker_current_salary) && (
                    <small className="text-muted text-capitalize">
                      {convertNumberToWords(
                        parseFloat(formData.jobseeker_current_salary)
                      )}
                    </small>
                  )}
                <br />
                {errors.jobseeker_current_salary && (
                  <small className="text-danger">
                    {errors.jobseeker_current_salary}
                  </small>
                )}
              </FormGroup>
            </Col>
            <Col md="6">
              <FormGroup>
                <Label for="jobseeker_preferred_salary">
                  Expected CTC <span className="font-danger">*</span>
                </Label>
                <Input
                  // type="number"
                  name="jobseeker_preferred_salary"
                  className="form-control form-control-sm"
                  placeholder="Enter expected ctc"
                  onInput={(e) => handleNumberInput(e, handleChange, 1, 990000000)}
                  value={formData.jobseeker_preferred_salary}
                // max={maxSalary} // Set the maximum limit
                />
                {formData.jobseeker_preferred_salary &&
                  !isNaN(formData.jobseeker_preferred_salary) && (
                    <small className="text-muted text-capitalize">
                      {convertNumberToWords(
                        parseFloat(formData.jobseeker_preferred_salary)
                      )}
                    </small>
                  )}
                <br />
                {errors.jobseeker_preferred_salary && (
                  <small className="text-danger">
                    {errors.jobseeker_preferred_salary}
                  </small>
                )}
              </FormGroup>
            </Col>
            {/* <Col md="6">
              <FormGroup>
                <Label for="jobseeker_preferred_job_type">
                  Job Preferences
                </Label>
                <Select
                  options={jobTypeOptions}
                  value={formData.jobseeker_preferred_job_type}
                  placeholder="Select job type..."
                  onChange={handleJobTypeChange}
                  styles={customOptionsStyle}
                />
                {errors.jobseeker_preferred_job_type && (
                  <small className="text-danger">
                    {errors.jobseeker_preferred_job_type}
                  </small>
                )}
              </FormGroup>
            </Col> */}
            {/* <Col md="6">
              <FormGroup>
                <Label for="jobseeker_preferred_shift">Shift Preference</Label>
                <Select
                  options={jobShiftOptions}
                  value={formData.jobseeker_preferred_shift}
                  placeholder="Select job shift..."
                  onChange={handleJobShiftChange}
                  styles={customOptionsStyle}
                />
                {errors.jobseeker_preferred_shift && (
                  <small className="text-danger">
                    {errors.jobseeker_preferred_shift}
                  </small>
                )}
              </FormGroup>
            </Col> */}
          </Row>

          <Row>
            {/*
          
            <Col md={6}>
              <FormGroup>
                <Label for="differently_abled">
                  Differently Abled
                  <span className="font-danger">*</span>
                </Label>
                <Select
                  options={yesnoOptions}
                  name="differently_abled"
                  value={formData.differently_abled}
                  onChange={handleDifferentlyAbledChange}
                />
                {errors.differently_abled && (
                  <small className="text-danger">
                    {errors.differently_abled}
                  </small>
                )}
              </FormGroup>
          
              */}
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            onClick={props.toggleModal}
            disabled={jobseekerProfileReducerData.isLoading}
          >
            Close
          </Button>
          <Button color="primary" type="submit">
            Update
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default Editpersonal;
